// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2y24D","noInteraction":"EventWrapper_noInteraction__coVjN"};